import { makeStyles, useTheme } from "@material-ui/styles";
import React from "react";
import { TaxiCompanyList } from "../../../../../services/taxi/GetDirectionAndFare/models/getFareSamplesParams";
import EasternLogoJP from './../images/eastern_airport_logo.png';
import EasternLogoEN from './../images/eastern_airport_logo_en.png';
import SandenLogo from './../images/sandenTaxiLogo.png';
import NahaHireLogo from './../images/nahaHireLogo.png';
import MiyakoTaxiLogo from './../images/miyakou-taxi-logo.jpg';
import HinomaruHireLogo from './../images/hinomaruHireLogo.png'
import IyotetsuLogo from './../images/iyotetsutaxi-logo.png';
import GotakuLogo from './../images/gotaku-logo.png';
import AsahikawachuuoLogo from './../images/asahikawa-chuuo-logo.png'
import HakodateTaxiLogo from './../images/hakodate-taxi-logo.png'

import DaiwaTaxiLogo from './../images/daiwa-taxi-logo.jpg';
import KitaFukushimaTaxiLogo from './../images/kita-fukushima-taxi-logo.jpg';
import FukushimaChuoTaxiLogo from './../images/fukushima-chuo-taxi-logo.jpg';
import IwakiTaxiLogo from './../images/iwaki-taxi-logo.jpg';
import UchigoTaxiLogo from './../images/uchigo-taxi-logo.jpg';
import TajimaTaxiLogo from './../images/tajima-taxi-logo.png';
import KinugawaTaxiLogo from './../images/kinugawa-taxi-logo.png';
import hokutocabLogo from './../images/hokto-taxi-logo.png';
import YokoTaxiLogo from './../images/yoko-taxi-logo.jpg';
import KingTaxiLogo from './../images/king-taxi-logo.png';
import TodenTaxiLogo from './../images/toden-taxi-logo.png';
import IshikawaKotsuLogo from './../images/ishikawa-taxi-logo.jpg';
import UbeKounaiLogo from './../images/ube-kounai-taxi-logo.png';
import TsuzuTaxiLogo from './../images/tsuzu-taxi-logo.png';
import SakataNo1TaxiLogo from './../images/sakata-no1taxi-logo.png';
import ShokoHireLogo from './../images/shoko-hire-logo.png';
import KisakataLogo from './../images/kisakata-logo.png';
import InariLogo from './../images/inari-logo.jpg';
import AbashiriLogo from './../images/abashiri-logo.png';
import TsubameLogo from './../images/tsubame-logo.jpg';
import HokurokuLogo from './../images/hokuroku-logo.png';

import DummyTaxiLogo from './../images/dummy_taxi_logo.png';

import { useSelector } from "react-redux";
import { State } from "../../../../../reducers";
import { Lang } from "../../../../../states/query";
import { isJapanese } from "../../../../../utils/lang";
import { useTranslation } from "react-i18next";

interface Props {
  company: TaxiCompanyList,
  lang: Lang
}

const useStyles = makeStyles(() => ({
  easternLogo: {
    margin: '10px 0px',
    width: '100%',
    maxHeight: '156px',
  },
  ubeSandenLogo: {
    margin: '10px 0px',
    width: '100%',
    maxWidth: '640px',
    maxHeight: '156px',
  },
  nahahireLogo: {
    margin: '10px 0px',
    width: '100%',
    maxWidth: '640px',
    maxHeight: '156px',
    background: '#000000'
  },
  miyakohLogo: {
    marginBottom: "10px",
    maxWidth: "468px",
    width: "100%",
  },
  iyotetsutaxiLogo: {
    margin: '10px 0px',
    width: "100%",
    maxWidth: 'min(640px, 100%)',
    maxHeight: '156px',
  },
  wideShortTaxiLogo: {
    margin: '10px 0px',
    maxWidth: 'min(640px, 100%)',
    maxHeight: '156px',
  },
  kinugawaTaxiLogo: {
    margin: '10px 0px',
    maxWidth: 'min(426px, 100%)',
    maxHeight: '156px',
  },
  body: {
    width: '100%',
    textAlign: 'center'
  }
}));

/**
 * 各タクシー会社の企業ロゴを表示する
 * @param props 会社名
 * @returns 企業ロゴComponents
 */
const ShowTaxiComapnyLogo: React.FC<Props> = (props: Props) => {
  const { i18n } = useTranslation();
  const theme = useTheme();
  const classes = useStyles(theme);
  const taxiCompanyConfigurations = useSelector((state: State) => state.general.taxiCompanyConfigurations);
  if(!taxiCompanyConfigurations) {
    return null;
  }
  const taxiCompanyConfiguration = taxiCompanyConfigurations[props.company] || taxiCompanyConfigurations[TaxiCompanyList.limoTaxi];
  const EasternLogo = isJapanese(i18n.language)? EasternLogoJP: EasternLogoEN;

  const Logos: { [keys in TaxiCompanyList]: string } = {
    [TaxiCompanyList.eastern]:        EasternLogo,
    [TaxiCompanyList.limoTaxi]:       EasternLogo,
    [TaxiCompanyList.miyakou]:        MiyakoTaxiLogo,
    [TaxiCompanyList.ubeSanden]:      SandenLogo,
    [TaxiCompanyList.nahahire]:       NahaHireLogo,
    [TaxiCompanyList.hinomaru]:       HinomaruHireLogo,
    [TaxiCompanyList.iyotetsutaxi]:   IyotetsuLogo,
    [TaxiCompanyList.iyotetsuTaxi2]:  IyotetsuLogo,
    [TaxiCompanyList.gotaku]:         GotakuLogo,
    [TaxiCompanyList.hakodateTaxi]:   HakodateTaxiLogo,
    [TaxiCompanyList.Asahikawachuuo]: AsahikawachuuoLogo,
    [TaxiCompanyList.daiwaj]:         DaiwaTaxiLogo,
    [TaxiCompanyList.kitafukushima]:  KitaFukushimaTaxiLogo,
    [TaxiCompanyList.fukushimachuo]:  FukushimaChuoTaxiLogo,
    [TaxiCompanyList.iwakiTaxi]:      IwakiTaxiLogo,
    [TaxiCompanyList['uchi-go']]:     UchigoTaxiLogo,
    [TaxiCompanyList.tajimaTaxi]:     TajimaTaxiLogo,
    [TaxiCompanyList.kinugawaTaxi]:   KinugawaTaxiLogo,
    [TaxiCompanyList.hokutocab]:      hokutocabLogo,
    [TaxiCompanyList.yotoTaxi]:       YokoTaxiLogo,
    [TaxiCompanyList.kingTaxi]:       KingTaxiLogo,
    [TaxiCompanyList.toden]:          TodenTaxiLogo,
    [TaxiCompanyList.ishikawakotsu]:  IshikawaKotsuLogo,
    [TaxiCompanyList.kingTaxi2]:      KingTaxiLogo,
    [TaxiCompanyList.ubeKounai]:      UbeKounaiLogo,
    [TaxiCompanyList.tsuzutaxi]:      TsuzuTaxiLogo,
    [TaxiCompanyList.sakataNo1Taxi]:  SakataNo1TaxiLogo,
    [TaxiCompanyList.shokoHire]:      ShokoHireLogo,
    [TaxiCompanyList.airport_liner]:  KisakataLogo,
    [TaxiCompanyList.nikaho_go]:      KisakataLogo,
    [TaxiCompanyList.inari]:          InariLogo,
    [TaxiCompanyList.inarihw]:        InariLogo,
    [TaxiCompanyList.abashiri]:       AbashiriLogo,
    [TaxiCompanyList.tsubame]:        TsubameLogo,
    [TaxiCompanyList.tsubamelimo]:    TsubameLogo,
    [TaxiCompanyList.hokuroku]:       HokurokuLogo,
    [TaxiCompanyList.dummyVal]:       DummyTaxiLogo,
  }
  const classNames: { [keys in TaxiCompanyList]: string } = {
    [TaxiCompanyList.eastern]:        classes.easternLogo,
    [TaxiCompanyList.limoTaxi]:       classes.easternLogo,
    [TaxiCompanyList.miyakou]:        classes.miyakohLogo,
    [TaxiCompanyList.ubeSanden]:      classes.ubeSandenLogo,
    [TaxiCompanyList.nahahire]:       classes.nahahireLogo,
    [TaxiCompanyList.hinomaru]:       classes.easternLogo,
    [TaxiCompanyList.iyotetsutaxi]:   classes.iyotetsutaxiLogo,
    [TaxiCompanyList.iyotetsuTaxi2]:  classes.iyotetsutaxiLogo,
    [TaxiCompanyList.gotaku]:         classes.wideShortTaxiLogo,
    [TaxiCompanyList.hakodateTaxi]:   classes.wideShortTaxiLogo,
    [TaxiCompanyList.Asahikawachuuo]: classes.wideShortTaxiLogo,
    [TaxiCompanyList.daiwaj]:         classes.wideShortTaxiLogo,
    [TaxiCompanyList.kitafukushima]:  classes.wideShortTaxiLogo,
    [TaxiCompanyList.fukushimachuo]:  classes.wideShortTaxiLogo,
    [TaxiCompanyList.iwakiTaxi]:      classes.easternLogo,
    [TaxiCompanyList['uchi-go']]:     classes.easternLogo,
    [TaxiCompanyList.tajimaTaxi]:     classes.wideShortTaxiLogo,
    [TaxiCompanyList.kinugawaTaxi]:   classes.kinugawaTaxiLogo,
    [TaxiCompanyList.hokutocab]:      classes.wideShortTaxiLogo,
    [TaxiCompanyList.yotoTaxi]:       classes.easternLogo,
    [TaxiCompanyList.kingTaxi]:       classes.wideShortTaxiLogo,
    [TaxiCompanyList.toden]:          classes.wideShortTaxiLogo,
    [TaxiCompanyList.ishikawakotsu]:  classes.wideShortTaxiLogo,
    [TaxiCompanyList.kingTaxi2]:      classes.wideShortTaxiLogo,
    [TaxiCompanyList.ubeKounai]:      classes.wideShortTaxiLogo,
    [TaxiCompanyList.tsuzutaxi]:      classes.wideShortTaxiLogo,
    [TaxiCompanyList.sakataNo1Taxi]:  classes.wideShortTaxiLogo,
    [TaxiCompanyList.shokoHire]:      classes.wideShortTaxiLogo,
    [TaxiCompanyList.airport_liner]:  classes.wideShortTaxiLogo,
    [TaxiCompanyList.nikaho_go]:      classes.wideShortTaxiLogo,
    [TaxiCompanyList.inari]:          classes.wideShortTaxiLogo,
    [TaxiCompanyList.inarihw]:        classes.wideShortTaxiLogo,
    [TaxiCompanyList.abashiri]:       classes.wideShortTaxiLogo,
    [TaxiCompanyList.tsubame]:        classes.wideShortTaxiLogo,
    [TaxiCompanyList.tsubamelimo]:    classes.wideShortTaxiLogo,
    [TaxiCompanyList.hokuroku]:       classes.wideShortTaxiLogo,
    [TaxiCompanyList.dummyVal]:       classes.easternLogo
  }
  const src = Logos[props.company];
  const className = classNames[props.company];
  return (
    <div className={classes.body}>
      <img
        src={src}
        alt={taxiCompanyConfiguration.logo.alt}
        className={className}
        data-cy={taxiCompanyConfiguration.cyName.logo}
      />
    </div>
  )
}

export default ShowTaxiComapnyLogo;
